;(function() {
"use strict";

(function(module) {
try {
  module = angular.module('app.templates');
} catch (e) {
  module = angular.module('app.templates', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/home/home.html',
    '<h1 class="flaticon-orientation51">Welcome {{homeCtrl.name}}</h1><a href="https://github.com/maxklenk/angular-sample-app" title="fork on Github"><img src="https://img.shields.io/github/forks/badges/shields.svg?style=social&label=Fork"></a> <img src="images/logo.png">');
}]);
})();
}());
